import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withState from 'recompose/withState';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import RequiredButton from '../atoms/RequiredButton';
import ValidationText from '../atoms/ValidationText';
import ProgressDialog from './ProgressDialog';
import { changeAccountEmailData } from '../../libs/apis/AccountApi';

const styles = theme => ({
  textField: {
    minWidth: 400
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  }
});

const enhance = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  withState('email', 'setEmail', ''),
  withState('validError', 'setValidError', ''),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('oldEmail', 'setOldEmail', props => {
    return props.old;
  })
);

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    message,
    setMessage,
    email,
    setEmail,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    shopId,
    validError,
    setValidError,
    oldEmail,
    setOldEmail
  }) => {
    function validEmail(address) {
      const pattern = new RegExp(
        /^(("[\w+-\s]+")|([\w+-]+(?:\.[\w+-]+)*)|("[\w+-\s]+")([\w+-]+(?:\.[\w+-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      return pattern.test(address);
    }

    function showErrorMessage() {
      setLoading(false);
      setMessage('メールアドレスの変更に失敗しました。');
    }

    function progressOkAction() {
      updateOpenProgress(false);
      updateOpenChange(false);
      setEmail('');
    }

    function cancelAction() {
      setEmail('');
      setValidError('');
      updateOpenChange(false);
    }

    function changeAction() {
      if (email === oldEmail) {
        setValidError('新しいメールアドレスを入力してください。');
        return;
      }
      if (!validEmail(email)) {
        setValidError('メールアドレスを正しく入力してください。');
      } else {
        setValidError('');
        updateOpenProgress(true);
        setLoading(true);
        changeAccountEmailData({
          shopId,
          email
        })
          .then(response => {
            if (response.status === 200) {
              setMessage('メールアドレスを変更しました。');
              setOldEmail(email);
              setLoading(false);
            } else {
              showErrorMessage();
            }
          })
          .catch(() => {
            showErrorMessage();
          });
      }
    }

    return (
      <>
        <Dialog
          open={openChange}
          onClose={() => {
            updateOpenChange(false);
            setEmail('');
            setValidError('');
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography component="p" className={classes.description}>
              メールアドレス変更
            </Typography>
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  現在のメールアドレス
                </TableCell>
                <TableCell>{oldEmail}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  変更後メールアドレス
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="メールアドレス"
                    placeholder="メールアドレス"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setEmail(e.target.value);
                    }}
                    inputProps={{
                      maxLength: 1000
                    }}
                    value={email}
                    onBlur={validEmail}
                  />
                  <ValidationText message={validError} />
                </TableCell>
              </TableRow>
            </Table>
          </DialogContent>
          <DialogActions>
            <CancelButton onClickAction={cancelAction} color="default" />
            <ChangeButton onClickAction={changeAction} />
          </DialogActions>
        </Dialog>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
